import { asyncRoutes } from '@/router/index.js'
// console.log(asyncRoutes)
// const child = [
//     {page: '1', name: '首页', children: [], parentId: null},
//     {page: '2', name: '基础设置', children:[
//         {
//            page: '2-1',
//             name: '学校',
//             parentId: 2,
//             child: []
//         },
//         {
//            page: '2-2',
//             name: '函授站',
//             parentId: 2,
//             child: []
//         },
//         {
//           page: '2-3',
//           name: 'www',
//           parentId: 2,
//           child: []
//       }
//     ]}
// ]
const getMenuIdList = (arr) => {
  let menuIdList = []
  arr.forEach(item => {
    menuIdList.push(item.page)
    if (item.children && item.children.length) {
      menuIdList = menuIdList.concat(getMenuIdList(item.children))
    }
  })
  return menuIdList.filter(item => item)
}

const filterMenuList = (routes, menuIdList) => {
  return routes.filter(item => menuIdList.includes(item.id)).map(item => {
    item = Object.assign({}, item)
    if (item.children && item.children.length) {
        item.children = filterMenuList(item.children, menuIdList)
    }
    return item
  })

}

const dealRoutes = (arr) => {
  // arr为后台传的权限数组
  const list = getMenuIdList(arr)
  const menuList = filterMenuList(asyncRoutes, list)
  return menuList
}

export default dealRoutes